import { SearchScenarioId } from 'owa-search-next-common';
import { action } from 'satcheljs';
import { EntityActionTakenType, Suggestion } from 'owa-search-service';

const suggestionSecondaryActionSelected = action(
    'suggestionSecondaryActionSelected',
    (
        suggestion: Suggestion,
        suggestionIndex: number,
        actionSource: string,
        scenarioId: SearchScenarioId,
        suggestionSetTraceId: string,
        entityActionTakenType: EntityActionTakenType
    ) => ({
        suggestion,
        suggestionIndex,
        actionSource,
        scenarioId,
        suggestionSetTraceId,
        entityActionTakenType,
    })
);

export default suggestionSecondaryActionSelected;
